import './Shop.scss'

import React, { Component } from 'react'
import moment from 'moment'
import { connect } from 'react-redux';
import RangeSelector from '../components/RangeSelector';
import { push } from 'connected-react-router'
import { Link } from 'react-router-dom'
import { PaymentOptions } from '../components'

import * as actions from '../actions'

class OrderSuccess extends Component {
    componentDidMount() {
        this.props.resetOrder();
    }

    render() {
        const props = this.props;

        return (
            <article className={"shop-page page"}>
                <section className="section gray-section on-screen">
                    <div className="sucsess-container"></div>
                    <div className="text-center">
                        <h1>Vielen Dank für Ihre Bestellung</h1>
                        <p>Sie erhalten in Kürze eine Bestätigung per E-Mail.</p>
                    </div>
                    <div className="hspace-container"></div>
                    <div className="text-center">
                        <Link to="/" className="white-btn ">Shop</Link>
                        <a href="https://vir-group.de/fahrsicherheits-centrum/" className="white-btn vspace-container">Webseite</a>
                    </div>
                </section>
            </article>
        )
    }
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {
        resetOrder: () => {
            dispatch(actions.resetOrder())
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OrderSuccess)


// WEBPACK FOOTER //
// ./src/pages/OrderSuccess.jsx